import {getLanguageTitle, decodeLocale} from '@hconnect/common/utils'
import {UIKIT_NAMESPACE} from '@hconnect/uikit'
import {MenuItemConfig} from '@hm/fundamental'
import {mdiAccountCircleOutline, mdiTranslate} from '@mdi/js'
import {useCallback, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {supportedLngs} from '../../../localization'

export function useGetLanguageMenuItem(): MenuItemConfig {
  const {t, i18n} = useTranslation()

  const selectLanguage = useCallback((lng: string) => void i18n.changeLanguage(lng), [i18n])
  const currentLanguage = i18n.language

  const getLanguageDisplayName = useCallback(
    (languageCode: string) => {
      const [language, country] = decodeLocale(languageCode)
      const languageTitle = getLanguageTitle(language, country)

      return languageTitle || t(`locales.${languageCode}`, {ns: UIKIT_NAMESPACE})
    },
    [t]
  )

  // note this is for fallback because we can never afford to show empty language name
  return useMemo(() => {
    const languagesMenuItems = Object.values(supportedLngs).map((l) => ({
      key: l,
      title: getLanguageDisplayName(l),
      icon: mdiAccountCircleOutline
    }))

    return {
      key: 'language',
      title: getLanguageDisplayName(currentLanguage),
      icon: mdiTranslate,
      type: 'select',
      onClicked: selectLanguage,
      selectedItem: currentLanguage,
      items: languagesMenuItems
    }
  }, [currentLanguage, selectLanguage, getLanguageDisplayName])
}
